import React, { FC } from 'react';
import { MainTemplate } from '../layouts';

const HomePage: FC<{}> = () => {
  return <MainTemplate pageName="Home Page" url="/" />;
};

export default HomePage;
